import { getLocalStorage, getCookie } from "../../../utils";
import BeEndpoints from "../../endpoints";
const analyitcsApi = (
  makeRequest,
  duration,
  limit,
  offset,
  { isCustom, startDate, endDate }
) => {
  let request;
  if (isCustom) {
    request = {
      path: `${BeEndpoints.Analyitcs}/${getLocalStorage(
        "venue"
      )}?filter_date=${duration}&limit=${limit}&offset=${offset}&date_from=${startDate}&date_to=${endDate}`,
      method: "GET",
      headers: {
        AUTHORIZATION: "Token " + getCookie("user_key"),
      },
    };
  } else {
    request = {
      path: `${
        BeEndpoints.Analyitcs +
        "/" +
        getLocalStorage("venue") +
        "?filter_date=" +
        duration +
        "&limit=" +
        limit +
        "&offset=" +
        offset
      }`,
      method: "GET",
      headers: {
        AUTHORIZATION: "Token " + getCookie("user_key"),
      },
    };
  }
  return makeRequest(request);
};
export { analyitcsApi };
